<template>
    <div
        v-if="open"
        class="fixed inset-0 z-[1000] flex items-center justify-center p-4"
        role="dialog"
        aria-modal="true"
    >
        <div class="absolute inset-0 bg-black/30" @click="close"></div>
        <div
            class="relative bg-bg-snow rounded-2xl shadow-xl w-full max-w-[480px] px-8 pt-12 pb-6 sm:px-12"
        >
            <button
                type="button"
                class="absolute top-4 right-4 z-10 p-2 text-fg-tertiary hover:text-fg-secondary"
                @click="close"
            >
                <Icon icon="close" class="w-5 h-5" />
            </button>

            <!-- Bank + 10x logo pair (v2 "For Export" asset) -->
            <img
                src="/images/spending/bank-connection-logo.png"
                alt=""
                class="mx-auto h-16 w-auto"
            />

            <h2
                class="mt-8 text-xl font-medium leading-7 text-fg-primary text-center"
            >
                Connect your bank to see your spending and rewards
            </h2>
            <p class="mt-2 text-sm text-fg-tertiary">
                Connect bank account to view your spending data and sync your
                bonus balance and linked cards automatically.
            </p>

            <ol class="mt-8 pb-8 space-y-4">
                <li
                    v-for="(step, i) in steps"
                    :key="i"
                    class="flex items-center gap-3"
                >
                    <span
                        class="flex-shrink-0 w-6 h-6 rounded-full bg-bg-base text-fg-primary text-xs font-medium flex items-center justify-center"
                    >
                        {{ i + 1 }}
                    </span>
                    <span class="text-sm text-fg-primary">{{ step }}</span>
                </li>
            </ol>

            <div class="flex justify-end gap-2">
                <button
                    type="button"
                    class="px-4 py-2.5 text-sm font-medium text-fg-primary bg-bg-snow border border-border-base rounded-lg hover:bg-bg-subtle transition-colors"
                    @click="close"
                >
                    Cancel
                </button>
                <button
                    type="button"
                    class="inline-flex items-center gap-2 px-4 py-2.5 text-sm font-semibold text-white bg-orange-500 rounded-lg hover:bg-orange-600 transition-colors"
                    @click="connect"
                >
                    <Icon icon="bank-add" class="w-5 h-5" />
                    Connect bank
                </button>
            </div>
        </div>
    </div>
</template>

<script setup>
import Icon from '@/components/ui/icon/icon.vue';

/*
 * Add Bank Connection modal (MY1-3029 item 2, v2 ".local -modal -add
 * connection"). Presentational: the parent decides when it opens and what
 * the Connect CTA does (today: the wallet MX flow).
 */
defineProps({
    open: {
        type: Boolean,
        default: false,
    },
    steps: {
        type: Array,
        default: () => [
            'Add a bank connection from your wallet',
            'Sign in to your bank account to authorize the connection',
            'Your spending will appear here once bank account is connected',
        ],
    },
});

const emit = defineEmits(['close', 'connect']);

const close = () => emit('close');
const connect = () => emit('connect');
</script>
